import '../../sass/plugins/highlight_carousel.scss';

import { EXTRA_LARGE_SCREEN, LARGE_SCREEN } from '../consts';

$(() => {
  const highlightCarousels = $('.highlight-carousel');

  // initialize each highlight carousel in app
  highlightCarousels.each((_, element) => {
    const highlightCarousel = $(element);
    const slider = highlightCarousel.find('.highlight-carousel__slider');
    const nextArrow = highlightCarousel.find('.secondary-navigator--right');
    const prevArrow = highlightCarousel.find('.secondary-navigator--left');

    const sliderElements = highlightCarousel.find(
      '.highlight-carousel__slider-element'
    );
    const moreThanThreeSlides = sliderElements.length > 3;

    slider.slick({
      infinite: moreThanThreeSlides,
      variableWidth: true,
      slidesToShow: 3,
      centerMode: true,
      centerPadding: '-20%',
      speed: 500,
      nextArrow,
      prevArrow,
      responsive: [
        {
          breakpoint: EXTRA_LARGE_SCREEN,
          settings: {
            variableWidth: !moreThanThreeSlides,
          },
        },
        {
          breakpoint: LARGE_SCREEN,
          settings: {
            infinite: true,
            variableWidth: true,
            slidesToShow: 1,
          },
        },
      ],
    });

    if (!moreThanThreeSlides) {
      slider.on('init setPosition', () => {
        // in case of only three slides, center on the middle slide on desktops
        const isDesktop = window.innerWidth > LARGE_SCREEN;
        if (isDesktop) {
          slider.slick('slickGoTo', 1, false);
        }
      });
    }
  });
});
